import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import {
  A3mediaPublicidad,
  A3mediaPublicidadDark,
  AbusoMercado,
  Agenda,
  Azure,
  Buzon,
  CanalConsultaDenuncias,
  Captio,
  Documentos,
  GRC,
  Incidencias,
  OfertasComerciales,
  Ondacero,
  PortalClente,
  Prisma,
  RegistroActividad,
  Salaria,
  SGLCajas,
  Sodexo,
  Taxis,
  Woffu,
  Workflow,
  ControlAcceso,
  GympassAccesoDirecto,
  AppsWidget,
  CoolCar,
  A3mia,
  BankinterAccesoDirecto,
  SantanderAccesoDirecto,
  IaIco,
  Apps as AppsIcon,
  ReconocimientoMedico,
  NewWorkflow
  // // AtresMerchandising
} from '../../../../assets/images/index';
import App from './App';
import {
  StyledBoxApps,
  StyledBoxAppsDark,
  StyledContentBoxApps,
  StyledListApps,
  StyledListAppsWidget,
  StyledSubtitle
} from './style';
import { StyledTitleApps } from '../MyApps/style';

const Apps = ({ className, dark, onClickBack, roles, show, userId, type }) => {
  const BoxApps = dark ? StyledBoxAppsDark : StyledBoxApps;
  const ListApps = dark ? StyledListApps : StyledListAppsWidget;
  const IconSubtitle = type === 'shortcutWidget' ? AppsIcon : AppsWidget;
  const prod = window.API_URL === 'https://intranetapi.atresmedia.com/';
  return (
    <BoxApps className={`${className} BoxApps`} show={show}>
      <StyledContentBoxApps show={show}>
        {roles.includes('ROLE_ACCESS_HCM') && (
          <>
            <ListApps className="Apps-item" show={show}>
              <a
                href={
                  prod
                    ? 'https://fa-extj-saasfaprod1.fa.ocs.oraclecloud.com/hcmUI/faces/FuseWelcome'
                    : 'https://fa-extj-test-saasfaprod1.fa.ocs.oraclecloud.com/fscmUI/faces/FuseWelcome'
                }
                rel="noopener noreferrer"
                target="_blank"
                id="linkComplaint"
              >
                <App
                  onClickBack={onClickBack}
                  icon={A3mia}
                  dark={dark}
                  className="fill"
                  id="a3mia"
                />
              </a>
            </ListApps>
            <ListApps className="Apps-item" show={show}>
              <a
                href="https://catalogo-ia.atresmedia.com/"
                target="_blank"
                rel="noopener noreferrer"
                id="linkIaCatalog"
              >
                <App
                  onClickBack={onClickBack}
                  title="Catalogo IA"
                  icon={IaIco}
                  dark={dark}
                  className="fill"
                  id="iconIaCatalog"
                />
              </a>
            </ListApps>
          </>
        )}
        {/* <ListApps className="Apps-item" show={show}>
          <a
            href="/catalogo/index.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            <App
              onClickBack={onClickBack}
              title="Merchandising Atresmedia"
              icon={AtresMerchandising}
              className="fill"
              id="iconAtresMerchandising"
            />
          </a>
        </ListApps> */}
        <ListApps className="Apps-item" show={show}>
          <a
            href={`perfil/${userId}/buzondesugerencias`}
            rel="noopener noreferrer"
            id="linkMailBox"
          >
            <App
              onClickBack={onClickBack}
              title="Buzón de sugerencias"
              icon={Buzon}
              dark={dark}
              className="fill"
              id="iconMailBox"
            />
          </a>
        </ListApps>
        <ListApps className="Apps-item" show={show}>
          <a
            href={
              prod
                ? 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=home'
                : 'https://intranetdev.atresmedia.com/atresnet/oauth?redirect=home'
            }
            target="_blank"
            rel="noopener noreferrer"
            id="linkWorkflow"
          >
            <App
              onClickBack={onClickBack}
              title="Workflow"
              icon={Workflow}
              dark={dark}
              className="fill"
              id="iconWorkflow"
            />
          </a>
        </ListApps>
        <ListApps className="Apps-item" show={show}>
          <a
            href="https://aura.atresmedia.com/Home.aspx"
            target="_blank"
            rel="noopener noreferrer"
            id="linkWorkflow"
          >
            <App
              onClickBack={onClickBack}
              title="Nuevo Workflow"
              icon={NewWorkflow}
              dark={dark}
              className="fill"
              id="iconNewWorkflow"
            />
          </a>
        </ListApps>
        <ListApps className="Apps-item" show={show}>
          <a
            href={
              prod
                ? 'https://intranetapi.atresmedia.com/sodexo/oauth?redirect=sodexo'
                : 'https://intranetpre.atresmedia.com/sodexo/oauth?redirect=sodexo'
            }
            // "https://api.mysodexo.app/sso_atresmedia"
            // href="https://api.mysodexo.app/sso_atresmedia"
            target="_blank"
            rel="noopener noreferrer"
            id="linkSodexo"
          >
            <App
              onClickBack={onClickBack}
              title="MySodexo"
              icon={Sodexo}
              dark={dark}
              className="fill"
              id="iconSodexo"
            />
          </a>
        </ListApps>
        {roles.includes('ROLE_ACCESS_PIDETAXI') && (
          <ListApps className="Apps-item" show={show}>
            <a
              href="https://alfa.a-rte.es:9898/SubscriberGroup/SubscriberGroup/Login/196"
              target="_blank"
              rel="noopener noreferrer"
              id="linkPidetaxi"
            >
              <App
                onClickBack={onClickBack}
                title="Taxis"
                icon={Taxis}
                dark={dark}
                className="fill"
                id="iconPidetaxi"
              />
            </a>
          </ListApps>
        )}
        {roles.includes('ROLE_ACCESS_CORPORATEAGENDA') && (
          <ListApps className="Apps-item" show={show}>
            <App
              onClickBack={onClickBack}
              title="Agenda corporativa"
              icon={Agenda}
              dark={dark}
              goTo="/agenda"
              className="fill"
              id="iconAgenda"
            />
          </ListApps>
        )}
        <ListApps className="Apps-item" show={show}>
          <App
            onClickBack={onClickBack}
            title="Directorio"
            icon={Documentos}
            dark={dark}
            goTo="/directorio_empleados"
            className="fill"
            id="iconDocuments"
          />
        </ListApps>{' '}
        <ListApps className="Apps-item" show={show}>
          <a
            href="https://atresmedia.atlassian.net/servicedesk/customer/portal/46"
            rel="noopener noreferrer"
            target="_blank"
            id="linkIncidences"
          >
            <App
              onClickBack={onClickBack}
              title="Help"
              icon={Incidencias}
              dark={dark}
              className="fill"
              id="iconIncidences"
            />
          </a>
        </ListApps>
        {roles.includes('ROLE_ACCESS_PRISMA') && (
          <ListApps className="Apps-item" show={show}>
            <a
              href={
                prod
                  ? 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=prims'
                  : 'https://intranetdev.atresmedia.com/atresnet/oauth?redirect=prims'
              }
              target="_blank"
              rel="noopener noreferrer"
              id="linkPrisma"
            >
              <App
                onClickBack={onClickBack}
                title="Prisma"
                icon={Prisma}
                dark={dark}
                className="fill"
                id="iconPrisma"
              />
            </a>
          </ListApps>
        )}
        {roles.includes('ROLE_ACCESS_CUSTOMERPORTAL') && (
          <ListApps className="Apps-item" show={show}>
            <a
              href="https://portalcomercial.atresmedia.com/"
              target="_blank"
              rel="noopener noreferrer"
              id="linkClientPortal"
            >
              <App
                onClickBack={onClickBack}
                title="Portal cliente"
                icon={PortalClente}
                dark={dark}
                className="fill"
                id="iconClientPortal"
              />
            </a>
          </ListApps>
        )}
        {roles.includes('ROLE_ACCESS_OC') && (
          <ListApps className="Apps-item" show={show}>
            <App
              onClickBack={onClickBack}
              title="Onda Cero"
              icon={Ondacero}
              dark={dark}
              goTo="/servicios-onda-cero"
              className="fill"
              id="iconOndacero"
            />
          </ListApps>
        )}
        {roles.includes('ROLE_ACCESS_SGL') && (
          <ListApps className="Apps-item" show={show}>
            <a
              href={
                prod
                  ? 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=sgl_box'
                  : 'https://intranetdev.atresmedia.com/atresnet/oauth?redirect=sgl_box'
              }
              target="_blank"
              rel="noopener noreferrer"
              id="linkSGL"
            >
              <App
                onClickBack={onClickBack}
                title="SGL-Cajas"
                icon={SGLCajas}
                dark={dark}
                className="fill"
                id="iconSGL"
              />
            </a>
          </ListApps>
        )}
        {roles.includes('ROLE_ACCESS_AZURE') && (
          <ListApps className="Apps-item" show={show}>
            <a
              href="https://i3television.visualstudio.com/"
              target="_blank"
              rel="noopener noreferrer"
              id="linkAzure"
            >
              <App
                onClickBack={onClickBack}
                title="Azure"
                icon={Azure}
                dark={dark}
                className="fill"
                id="iconAzure"
              />
            </a>
          </ListApps>
        )}
        {roles.includes('ROLE_ACCESS_WOFFU') && (
          <ListApps className="Apps-item" show={show}>
            <a
              href="https://i3television.woffu.com"
              target="_blank"
              rel="noopener noreferrer"
              id="linkWoffu"
            >
              <App
                onClickBack={onClickBack}
                title="Woffu"
                icon={Woffu}
                dark={dark}
                className="fill"
                id="iconWoffu"
              />
            </a>
          </ListApps>
        )}
        {roles.includes('ROLE_ACCESS_SUBCOMMERCIAL') && (
          <ListApps className="Apps-item" show={show}>
            <a
              href={
                prod
                  ? 'https://atresmedia.sharepoint.com/sites/comercial_tv'
                  : 'https://atresmedia.sharepoint.com/sites/comercial_tv'
              }
              target="_blank"
              rel="noopener noreferrer"
              id="linkPublicity"
            >
              <App
                className="atresmedia-publicidad"
                onClickBack={onClickBack}
                title="Atresmedia Publicidad"
                icon={dark ? A3mediaPublicidadDark : A3mediaPublicidad}
                dark={dark}
                id="iconPublicity"
              />
            </a>
          </ListApps>
        )}
        {roles.includes('ROLE_ACCESS_CAPTIO') && (
          <ListApps className="Apps-item" show={show}>
            <a
              href="https://login.captio.net"
              target="_blank"
              rel="noopener noreferrer"
              id="linkCaptio"
            >
              <App
                onClickBack={onClickBack}
                title="Captio"
                icon={Captio}
                dark={dark}
                className="fill"
                id="iconCaptio"
              />
            </a>
          </ListApps>
        )}
        {roles.includes('ROLE_ACCESS_PLATAFORMA_HORAS') && (
          <ListApps className="Apps-item" show={show}>
            <a
              href="https://plataformahoras.atresmedia.com/"
              rel="noopener noreferrer"
              target="_blank"
              id="linkActivityRegister"
            >
              <App
                onClickBack={onClickBack}
                title="Registro de Actividad"
                icon={RegistroActividad}
                dark={dark}
                className="fill"
                id="iconActivityRegister"
              />
            </a>
          </ListApps>
        )}
        {roles.includes('ROLE_ACCESS_GRC') && (
          <ListApps className="Apps-item" show={show}>
            <a
              href="https://sapgrcp01.antena3tv.es:1443/sap/bc/ui2/flp#Shell-home"
              rel="noopener noreferrer"
              target="_blank"
              id="linkGRC"
            >
              <App
                onClickBack={onClickBack}
                title="GRC"
                icon={GRC}
                dark={dark}
                className="fill"
                id="iconGRC"
              />
            </a>
          </ListApps>
        )}
        <ListApps className="Apps-item" show={show}>
          <a
            href="https://www.atresmediacorporacion.com/gobierno-corporativo/cumplimiento-normativo-prevencion-penal/"
            rel="noopener noreferrer"
            target="_blank"
            id="linkComplaint"
          >
            <App
              onClickBack={onClickBack}
              title="Canal de consultas y denuncias"
              icon={CanalConsultaDenuncias}
              dark={dark}
              className="fill"
              id="iconComplaint"
            />
          </a>
        </ListApps>
        {roles.includes('ROLE_ACCESS_ABUSO_MERCADO') && (
          <ListApps className="Apps-item" show={show}>
            <a
              href="https://cims.computershare.com"
              rel="noopener noreferrer"
              target="_blank"
              id="linkMarketAbuse"
            >
              <App
                onClickBack={onClickBack}
                title="Abuso de mercado"
                icon={AbusoMercado}
                dark={dark}
                className="fill"
                id="iconMarketAbuse"
              />
            </a>
          </ListApps>
        )}
        {roles.includes('ROLE_ACCESS_ACCESSCONTROL') && (
          <ListApps className="Apps-item" show={show}>
            <a
              href="perfil/control-acceso"
              target="_blank"
              rel="noopener noreferrer"
              id="linkAccesControl"
            >
              <App
                onClickBack={onClickBack}
                title="Control de acceso"
                icon={ControlAcceso}
                dark={dark}
                className="fill"
                id="iconAccesControl"
              />
            </a>
          </ListApps>
        )}
        {roles.includes('ROLE_ACCESS_MEDICO') && (
          <ListApps className="Apps-item" show={show}>
            <a
              href="https://aura.atresmedia.com/BPM_Mensajes_Crear.aspx?VjBRnzTw8nT7coXWnl4rPyblOOUnINUmwg94/gKZa9s="
              target="_blank"
              rel="noopener noreferrer"
              id="linkMedicalCheck"
            >
              <App
                onClickBack={onClickBack}
                title="Reconocimiento Médico"
                icon={ReconocimientoMedico}
                dark={dark}
                className="fill"
                id="iconMedicalCheck"
              />
            </a>
          </ListApps>
        )}
      </StyledContentBoxApps>
      {roles.includes('ROLE_ACCESS_A3MBENEFITS') && (
        <>
          {className !== 'MenuBurguer' ? (
            <StyledSubtitle
              title="Ventajas AtresMedia"
              icon={IconSubtitle}
              type="shortcut"
              className={type === 'shortcutWidget' ? 'WidgetBox-title' : ''}
            />
          ) : (
            <StyledTitleApps>Ventajas AtresMedia</StyledTitleApps>
          )}
          <StyledContentBoxApps show={show}>
            {roles.includes('ROLE_ACCESS_SALARIA') && (
              <ListApps className="Apps-item" show={show}>
                <a
                  href={
                    prod
                      ? 'https://intranetapi.atresmedia.com/atresnet/oauth?redirect=salaria'
                      : 'https://intranetpre.atresmedia.com/atresnet/oauth?redirect=salaria'
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  id="linkSalaria"
                >
                  <App
                    onClickBack={onClickBack}
                    title="Retribución Flexible"
                    icon={Salaria}
                    dark={dark}
                    className="fill"
                    id="iconSalaria"
                  />
                </a>
              </ListApps>
            )}
            {roles.includes('ROLE_ACCESS_BENEFITS') && (
              <ListApps className="Apps-item" show={show}>
                <a
                  href="http://atresmil.clubdebenefits.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  id="linkClubBenefits"
                >
                  <App
                    onClickBack={onClickBack}
                    title="A3Mil Benefits"
                    icon={OfertasComerciales}
                    dark={dark}
                    className="fill"
                    id="iconClubBenefits"
                  />
                </a>
              </ListApps>
            )}
            {roles.includes('ROLE_ACCESS_GYMPASS') && (
              <ListApps className="Apps-item" show={show}>
                <a
                  href="https://www.gympass.com/sign-up/company-search/?user_country=es&user_language=es"
                  target="_blank"
                  rel="noopener noreferrer"
                  id="linkGympass"
                >
                  <App
                    onClickBack={onClickBack}
                    title="Wellhub"
                    icon={GympassAccesoDirecto}
                    dark={dark}
                    className="fill"
                    id="iconGympassAccesoDirecto"
                  />
                </a>
              </ListApps>
            )}
            {roles.includes('ROLE_ACCESS_BANKINTER') && (
              <>
                <ListApps className="Apps-item" show={show}>
                  <a
                    href="https://a3mil.atresmedia.com/noticia/65b225bd607b4a000173898f"
                    target="_blank"
                    rel="noopener noreferrer"
                    id="linkBankinter"
                  >
                    <App
                      onClickBack={onClickBack}
                      title="Bankinter"
                      icon={BankinterAccesoDirecto}
                      dark={dark}
                      className="fill"
                      id="iconBankinterAccesoDirecto"
                    />
                  </a>
                </ListApps>

                <ListApps className="Apps-item" show={show}>
                  <a
                    href="https://a3mil.atresmedia.com/noticia/68480bbedf2bbf0001b5c40c"
                    target="_blank"
                    rel="noopener noreferrer"
                    id="linkSantander"
                  >
                    <App
                      onClickBack={onClickBack}
                      title="Santander"
                      icon={SantanderAccesoDirecto}
                      dark={dark}
                      className="fill"
                      id="iconSantanderAccesoDirecto"
                    />
                  </a>
                </ListApps>
              </>
            )}
            {roles.includes('ROLE_ACCESS_COOLCAR') && (
              <ListApps className="Apps-item" show={show}>
                <a
                  href="https://a3mil.atresmedia.com/noticia/650d5e21e3882e0001780421"
                  target="_blank"
                  rel="noopener noreferrer"
                  id="linkCoolCar"
                >
                  <App
                    onClickBack={onClickBack}
                    title="Punto de Carga"
                    icon={CoolCar}
                    dark={dark}
                    className="fill"
                    id="iconCoolCar"
                  />
                </a>
              </ListApps>
            )}
          </StyledContentBoxApps>
        </>
      )}
    </BoxApps>
  );
};

Apps.propsType = {
  className: PropTypes.string,
  dark: PropTypes.bool
};

const mapStateToProps = state => ({
  userId: state.user.user.userId,
  roles: state.user.user.roles
});

export default connect(mapStateToProps)(Apps);
